import React from 'react';
import * as _ from 'lodash';
import { Payment, RefundDescription } from 'guest-data-types-ts-lib/types';
import { PaymentAmount } from 'guest-data-types-ts-lib';
import { ImageDiscoverCard, ImageMasterCard, ImagePlaceHolderCard, ImageVisaCard } from '../../assets/images';
import moment from 'moment';
import { CurrencyUtils, TranslationUtils } from '../../utils';
import './RefundDetails.scss';

interface CreditCardDetailItem {
    logo: JSX.Element;
    lastFour: string | null;
    amount: PaymentAmount;
    description?: string;
}

const CreditCardDetailItem: React.FC<CreditCardDetailItem> = (props) => {
    const { logo, lastFour, amount, description } = props;

    return (
        <div className="credit-card-detail-item">
            <div className="credit-card-detail-item-card">
                <div className="credit-card-detail-item-logo">{logo}</div>
                <div className="credit-card-detail-item-card-details">
                    <div className="credit-card-detail-item-card-details-numbers">{`**** ***** ***** ${lastFour}`}</div>
                    {description && <div className="credit-card-detail-item-card-details-description">{description}</div>}
                </div>
            </div>
            <div className="credit-card-detail-item-amount">{CurrencyUtils.formatCurrency(amount.total, amount.currency)}</div>
        </div>
    );
};

interface RefundDetailsProps {
    refund: RefundDescription;
    className?: string;
}

export const RefundDetails: React.FC<RefundDetailsProps> = (props) => {
    const { refund, className } = props;

    const images: { [type: string]: JSX.Element } = {
        VISA: <ImageVisaCard />,
        MC: <ImageMasterCard />,
        DISC: <ImageDiscoverCard />,
        default: <ImagePlaceHolderCard />,
    };

    return (
        <div className={`refund-details ${className ?? ''}`}>
            <p className="refund-details-title">{TranslationUtils.get('refund_details')}</p>

            <div className="refund-details-message">
                <span>{TranslationUtils.get('refund_going_to')}:</span> <br />
                <span className="refund-details-message-muted">{TranslationUtils.get('original_payment_methods')}</span>
            </div>

            {refund.distribution.map((card, i) => (
                <CreditCardDetailItem
                    key={i}
                    logo={images[card.method_type || ''] ?? images.default}
                    amount={{ total: card.refund_amount.total, currency: card.refund_amount.currency }}
                    lastFour={card.last_four}
                    description={TranslationUtils.get('guest_paid', {
                        amount: CurrencyUtils.formatCurrency(card.paid_amount.total, card.paid_amount.currency),
                        date: moment(card.paid_date).format('YYYY-MM-DD'),
                    })}
                />
            ))}

            <hr className="refund-divider" />
            <div className="refund-details-total">
                {CurrencyUtils.formatCurrency(refund.total_refund_amount.total, refund.total_refund_amount.currency)}
            </div>
        </div>
    );
};
